export const surveyFields = [
  {
    name: "visible_mold",
    label: "Visible Mold",
    question: "Was there any visible mold?",
    type: "radio",
    options: [
      { label: "Yes", value: true },
      { label: "No", value: false },
    ],
  },
  {
    name: "visible_cockroaches",
    label: "Cockroaches",
    question: "Was there any visible Cockroaches or droppings?",
    type: "radio",
    options: [
      { label: "Yes", value: true },
      { label: "No", value: false },
    ],
  },
  {
    name: "mice_rats",
    label: "Mice/Rats",
    question: "Visual Mice or Rats, and or droppings?",
    type: "group",
    fields: [
      {
        name: "visible_mice",
        label: "Mice",
        type: "radio",
        options: [
          { label: "Yes", value: true },
          { label: "No", value: false },
        ],
      },
      {
        name: "visible_rats",
        label: "Rats",
        type: "radio",
        options: [
          { label: "Yes", value: true },
          { label: "No", value: false },
        ],
      },
    ],
  },
  {
    name: "notes",
    label: "Other",
    question: "",
    type: "textarea",
  },
];

export const surveyDetailsFields = [
  { name: "investigated_by", label: "Investigated By", type: "text", size: 12 },
  {
    name: "relationship_to_building",
    label: "Relationship to Building",
    type: "text",
    size: 6,
  },
  {
    name: "investigate_date",
    label: "Investigation Date",
    type: "date",
    size: 6,
  },
];